/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-23 16:09:46
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-11 15:10:46
 */
import request from '../../utils/request'
import server from './config'
export default {
  /**
   * 获取计划列表
   */
  getPlanList:(data,noToast = false)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/doctorPlanRecord/1/getPageList`,
      method: 'post',
      data,
      noToast
    })
  },
  //获取详情
  getDetail:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/doctorPlanRecord/1/getDetailById`,
      method: 'post',
      data,
    })
  },
  //详情设置已读
  setReaded:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/doctorPlanRecord/1/setReaded`,
      method: 'post',
      data,
    })
  },
  //获取提醒 表单详情
  getremindOrFormDetail:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/doctorPlanRecord/1/getNoticeOrFormDetailById`,
      method: 'post',
      data,
    })
  },
  patientPlanList:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/doctorPlanRecord/1/patientPlanList`,
      method: 'post',
      data,
    })
  },
  saveAns:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/doctorPlanRecord/1/saveAns`,
      method: 'post',
      data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/plan.js